import React, { useRef, useEffect } from 'react';
import { addEvent, removeEvent } from 'ava-util/dist/dom-event';
import { getWindowHeight } from 'ava-util/dist/dom-window';

type ScopeAffixProps = {
    target: () => HTMLElement | null;
    offset?: number; //固定元素距离屏幕顶端的距离
    className?: string;
    disabled?: boolean;
    children?: React.ReactNode;
};

const ScopeAffix: React.FC<ScopeAffixProps> = props => {
    const affixRef = useRef<HTMLDivElement>(null);
    const stateRef = useRef<Record<string, any>>({});

    const {
        target,
        className,
        offset = 0,
        disabled = false,
        children,
    } = props;

    const calculate = () => {
        let dist: number = 0;
        const affix = affixRef.current;
        const target = stateRef.current.target;
        if (affix && target) {
            const affixHeight = affix.offsetHeight;
            const targetHeight = target.offsetHeight;
            // 浮动元素比浏览器窗口高度小时不浮动，比target元素高度小时也不浮动
            if ((affixHeight + offset) <= stateRef.current.windowHeight && (affixHeight + offset) < targetHeight) {
                const targetTop = target.getBoundingClientRect().top;
                if (targetTop - offset < 0) {
                    dist = Math.min(Math.abs(targetTop - offset), targetHeight - affixHeight);
                }
            }
            affix.style.transform = `translate3d(0px, ${dist}px, 0px)`;
        }
    };

    const handleScroll = () => {
        calculate();
    };

    const handleResize = () => {
        stateRef.current.windowHeight = getWindowHeight();
        calculate();
    };

    useEffect(() => {
        if (!affixRef.current || disabled) {
            return;
        }
        const domTarget = target() || affixRef.current.parentNode;
        if (!domTarget) {
            return;
        }
        stateRef.current.target = domTarget;
        // 初始化
        handleResize();
        handleScroll();
        addEvent(window, 'resize', handleResize);
        addEvent(window, 'scroll', handleScroll);
        return () => {
            removeEvent(window, 'resize', handleResize);
            removeEvent(window, 'scroll', handleScroll);
        };
    }, []);

    return (
        <div ref={affixRef} className={className}>
            {children}
        </div>
    )
};

export default ScopeAffix;